define("shared/modifiers/show-on-hover", ["exports", "@ember/debug", "@ember/object", "ember-modifier"], function (_exports, _debug, _object, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class;
  0; //eaimeta@70e063a35619d71f0,"@ember/debug",0,"@ember/object",0,"ember-modifier"eaimeta@70e063a35619d71f
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  /**
   *
   * @class ShowOnHoverModifier
   * @extends Modifier
   *
   * This handles adding an event listener to the target element
   * to add/remove a `u--hide` class from a child element with the
   * given class name
   *
   * Positional Parameters:
   * @param {String} child The class name of the child element to show on hover
   *
   * Examples:
   *
   * Simple Usage:
   *
   * Adds an event listener to the parent `div` and removes it when the `div` is destroyed.
   * Shows the child div by removing the `u--hide` class when hovering over the parent div.
   *
   * ```
   * <div {{show-on-hover "child-to-show"}}>
   *  <div class="u--hide child-to-show">Hello!</div>
   * <div>
   * ```
   */
  let ShowOnHoverModifier = _exports.default = (_class = class ShowOnHoverModifier extends _emberModifier.default {
    get child() {
      const className = this.args.positional[0];
      return this.element?.getElementsByClassName(className)[0];
    }
    showChild() {
      this.child?.classList.remove('u--hide');
    }
    hideChild() {
      this.child?.classList.add('u--hide');
    }
    didReceiveArguments() {
      (false && !(this.child) && (0, _debug.assert)('Must provide the class name of a child element', this.child));
      if (this.child) {
        this.removeEventListener();
        this.addEventListener();
      }
    }
    willRemove() {
      this.removeEventListener();
    }
    addEventListener() {
      this.element.addEventListener('mouseover', this.showChild);
      this.element.addEventListener('mouseout', this.hideChild);
    }
    removeEventListener() {
      this.element.removeEventListener('mouseover', this.showChild);
      this.element.removeEventListener('mouseout', this.hideChild);
    }
  }, (_applyDecoratedDescriptor(_class.prototype, "showChild", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "showChild"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideChild", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "hideChild"), _class.prototype)), _class);
});